import { AfterViewInit, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { FirebaseAuthService } from '../../../shared/firebase-auth.service';
import { LandingTopAppBarComponent } from '../../shared/ui/landing-top-app-bar/landing-top-app-bar.component';

import { MatExpansionModule } from '@angular/material/expansion';

/** Error page shown when the user's domain or account is not on the authorized allow-list. */
@Component({
  selector: 'app-unauthorized',
  imports: [CommonModule, MatButtonModule, MatIconModule, MatExpansionModule, LandingTopAppBarComponent],
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
})
export class UnauthorizedComponent implements AfterViewInit {
  private route = inject(ActivatedRoute);
  private authService = inject(FirebaseAuthService);

  email: string | null = null;
  denialMessage: string | null = null;
  user$ = this.authService.user$;
  authorizationError$ = this.authService.authorizationError$;

  @ViewChild('statusHeading') private statusHeading?: ElementRef<HTMLElement>;

  constructor() {
    this.route.queryParams.subscribe(params => {
      this.email = params['email'];
      this.denialMessage = params['message'];
    });
  }

  ngAfterViewInit(): void {
    queueMicrotask(() => this.statusHeading?.nativeElement.focus());
  }

  switchAccount() {
    // Force Google account chooser without signing out first
    // This prevents the UI leak that occurs during sign-out -> sign-in transition
    this.authService.signIn(true);
  }

  /**
   * Sign out completely (for untrusted computers)
   */
  signOut() {
    this.authService.signOut();
  }
}
